import { LatLng, Map, Marker as MarkerEntity, TileLayer as TileLayerEntity } from 'leaflet';
import { useRef } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import Control from 'react-leaflet-custom-control';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'src/lib/components/Button.component';
import { TextArea } from 'src/lib/components/TextArea.component';
import { TextInput } from 'src/lib/components/TextInput.component';
import { toasting } from 'src/lib/components/Toast.component';
import { fpost } from 'src/lib/fetch';
import { SelectBoxBaseLayer } from 'src/modules/map-layers/components/SelectBoxBaseLayer.component';
import { MarkerMapControl } from 'src/modules/map-markers/components/MarkerMapControl.component';
import { MAPBOX_TILE_LAYER_PROPS } from 'src/redux/slices/baseLayer.slice';
import { CreateAreaReq } from '../../dto/area/area.req';

export function CreateAreaPage() {
  const eForm = useRef<HTMLFormElement>(null);

  const eTextName = useRef<HTMLInputElement>(null);
  const eTextDetail = useRef<HTMLTextAreaElement>(null);
  const eTextCoordinateX = useRef<HTMLInputElement>(null);
  const eTextCoordinateY = useRef<HTMLInputElement>(null);

  const eButtonSubmit = useRef<HTMLButtonElement>(null);

  const baseTileLayer = useRef<TileLayerEntity>(new TileLayerEntity(''));
  const map = useRef<Map>(null);
  const eMarker = useRef<MarkerEntity>(null);

  const navigate = useNavigate();

  const handleButtonSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    if (!eForm.current?.checkValidity()) {
      return eForm.current?.reportValidity();
    }

    try {
      await fpost<CreateAreaReq>('api/areas', {
        body: {
          area: {
            AREA_NAME: eTextName.current?.value || '',
            DETAIL: eTextDetail.current?.value || '',
            AREA_COORDINATE: `${eTextCoordinateX.current?.value || ''},${eTextCoordinateY.current?.value || ''}`,
          },
        },
      });

      navigate('..');
    } catch (error) {
      console.error(error);
      toasting({ children: '何か問題が発生しました', containerProps: { className: 'border-red-600' } });
    }
  };

  return (
    <form className="flex flex-row flex-wrap px-4 pt-12 md:px-12 md:py-8" ref={eForm}>
      <h1 className="mb-2 whitespace-nowrap text-2xl">地域追加</h1>
      <span className="w-full border-b border-slate-800"></span>

      <div className="mt-8 flex flex-nowrap gap-8">
        <div className="flex w-2/3 flex-row flex-wrap gap-8">
          <TextInput
            labelProps={{
              children: '地域名',
            }}
            type="text"
            containerProps={{
              className: 'basis-full',
              style: {
                minWidth: '12rem',
              },
            }}
            required
            ref={eTextName}
          />

          <div className="flex basis-full flex-col">
            <label className="mb-2 text-sm font-normal text-gray-900 dark:text-white">代表座標</label>
            <div className="flex flex-row flex-wrap justify-between gap-4">
              <TextInput
                labelProps={{
                  className: 'mb-0 mr-2',
                  children: 'X',
                }}
                type="text"
                containerProps={{
                  className: 'flex flex-row items-center',
                  style: {
                    minWidth: '12rem',
                  },
                }}
                required
                onChange={(e) => {
                  if (eTextCoordinateY.current?.value)
                    eMarker.current?.setLatLng(new LatLng(+e.target.value, +eTextCoordinateY.current.value));
                }}
                ref={eTextCoordinateX}
              />

              <TextInput
                labelProps={{
                  className: 'mb-0 mr-2',
                  children: 'Y',
                }}
                type="text"
                containerProps={{
                  className: 'flex flex-row items-center',
                  style: {
                    minWidth: '12rem',
                  },
                }}
                required
                onChange={(e) => {
                  if (eTextCoordinateX.current?.value)
                    eMarker.current?.setLatLng(new LatLng(+e.target.value, +eTextCoordinateX.current.value));
                }}
                ref={eTextCoordinateY}
              />
            </div>
          </div>

          <TextArea
            labelProps={{
              value: '説明',
            }}
            containerProps={{
              className: 'basis-full',
              style: {
                minWidth: '12rem',
              },
            }}
            className="custom-scrollbar-1 rounded-t-md"
            ref={eTextDetail}></TextArea>

          <Button
            className="basis-full justify-center rounded-md bg-black text-xs text-white"
            style={{
              minWidth: '256px',
            }}
            type="submit"
            onClick={handleButtonSubmit}
            ref={eButtonSubmit}>
            追加
          </Button>
          <Link
            className={'mx-auto w-full  basis-full rounded-md border border-gray-600  p-2 text-center'}
            to=".."
            style={{
              minWidth: '256px',
            }}>
            キャンセル
          </Link>
        </div>

        <MapContainer
          attributionControl={false}
          minZoom={5}
          zoom={9}
          center={[33.9195, 133.1811]}
          style={{
            minHeight: '60vh',
            minWidth: '20rem',
            border: '0.25rem solid',
            flexBasis: '100%',
          }}
          ref={map}>
          <TileLayer {...MAPBOX_TILE_LAYER_PROPS} ref={baseTileLayer} maxNativeZoom={18} />
          <Control
            position="topright"
            container={{
              className: 'flex bg-none flex-col',
            }}>
            <SelectBoxBaseLayer baseTileLayer={baseTileLayer} />
          </Control>

          <MarkerMapControl
            ref={eMarker}
            onClickMap={(e) => {
              eTextCoordinateX.current &&
                eTextCoordinateY.current &&
                (eTextCoordinateX.current.value = `${e.latlng.lat}`) &&
                (eTextCoordinateY.current.value = `${e.latlng.lng}`);

              return true;
            }}
          />
        </MapContainer>
      </div>
    </form>
  );
}
